import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/importer.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import GlobalStyles from "./assets/styles/globalStyles";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./utils/store";
import { ToastContainer } from "react-toastify";
import { getToastIcon } from "./utils/helper";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <App />
          <ToastContainer
            icon={({ type }) => getToastIcon(type)}
            autoClose={3000}
            position={"top-center"}
            closeButton={false}
            hideProgressBar={true}
          />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
